import React, { useState } from 'react';
import { Download } from 'lucide-react';

// SMS Review Modal Component
export const SMSReviewModal = ({ review, onSave, onClose }) => {
  const [formData, setFormData] = useState(review || {
    reviewType: 'full',
    reviewDate: new Date().toISOString().split('T')[0],
    reviewer: '',
    findings: [],
    actions: [],
    notes: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full">
          <div className="px-6 py-4 border-b">
            <h3 className="text-lg font-medium text-gray-900">
              {review ? 'View Review' : 'Record SMS Review'}
            </h3>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">Review Type</label>
                  <select
                    value={formData.reviewType}
                    onChange={(e) => setFormData({...formData, reviewType: e.target.value})}
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                    required
                  >
                    <option value="full">Full Review</option>
                    <option value="partial">Partial Review</option>
                    <option value="audit">Audit</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">Review Date</label>
                  <input
                    type="date"
                    value={formData.reviewDate}
                    onChange={(e) => setFormData({...formData, reviewDate: e.target.value})}
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Reviewer</label>
                <input
                  type="text"
                  value={formData.reviewer}
                  onChange={(e) => setFormData({...formData, reviewer: e.target.value})}
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                  placeholder="Name of reviewer"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Notes</label>
                <textarea
                  value={formData.notes}
                  onChange={(e) => setFormData({...formData, notes: e.target.value})}
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm"
                  rows="4"
                  placeholder="Review notes and observations..."
                />
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              {!review && (
                <button
                  type="submit"
                  className="px-4 py-2 bg-cyan-600 text-white rounded-md hover:bg-cyan-700"
                >
                  Save Review
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// Report View Modal Component
export const ReportViewModal = ({ report, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-25" onClick={onClose} />
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div className="px-6 py-4 border-b flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">Compliance Report</h3>
            <div className="flex items-center space-x-3">
              <button className="px-3 py-1 bg-cyan-600 text-white rounded-md hover:bg-cyan-700 flex items-center">
                <Download className="h-4 w-4 mr-1" />
                Export PDF
              </button>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-600">×</button>
            </div>
          </div>

          <div className="p-6">
            <div className="mb-6">
              <h4 className="text-lg font-medium text-gray-900">Vessel: {report.vessel?.name}</h4>
              <p className="text-sm text-gray-500">Generated: {new Date(report.generatedAt).toLocaleString()}</p>
              <p className="text-sm text-gray-500">Report ID: {report.id}</p>
            </div>

            <div className="prose max-w-none">
              <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
                {JSON.stringify(report.data, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};